module.exports = __webpack_public_path__ + "img/netiqlogo-small.63ee845c.png";